/**
 * PostHog super-properties for the current app and deployment environment.
 * Keys are omitted when the corresponding env var is unset.
 */
export function getPosthogContextProperties(): Record<string, string> {
  const app_id = process.env.NEXT_PUBLIC_APP_ID;
  const environment = process.env.NEXT_PUBLIC_VERCEL_ENV;

  return {
    ...(app_id ? { app_id } : {}),
    ...(environment ? { environment } : {}),
  };
}
